module.exports = __webpack_public_path__ + "img/WS.425980a0.png";